import { render } from "./HereditaryCaseFilter.vue?vue&type=template&id=0a356ec0&scoped=true"
import script from "./HereditaryCaseFilter.vue?vue&type=script&lang=js"
export * from "./HereditaryCaseFilter.vue?vue&type=script&lang=js"

import "./HereditaryCaseFilter.vue?vue&type=style&index=0&id=0a356ec0&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a356ec0"]])

export default __exports__